const level = (s) =>
  s >= 80 ? { label: "High agreement", color: "#D4FF3A" }
  : s >= 50 ? { label: "Mixed agreement", color: "#FBBF24" }
  : { label: "Low agreement", color: "#F87171" };

const Bar = ({ label, score, color, testid }) => (
  <div className="flex items-center gap-4">
    <span className="text-[11px] font-mono uppercase tracking-[0.1em] text-slate-500 shrink-0 w-32 whitespace-nowrap">{label}</span>
    <div className="flex-1 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
      <div className="h-full rounded-full what-grow" style={{ width: `${score}%`, background: color }} />
    </div>
    <span data-testid={testid} className="font-mono text-sm shrink-0 w-10 text-right" style={{ color }}>{score}%</span>
  </div>
);

export const AgreementMeter = ({ agreement, after }) => {
  const shown = after || agreement;
  const { label, color } = level(shown.score);
  return (
    <div data-testid="agreement-meter" className="mt-6 pt-5 border-t border-white/[0.06] space-y-2">
      <Bar label={after ? "Before debate" : "AI agreement"} score={agreement.score} color={after ? "#64748B" : color} testid="agreement-score" />
      {after && <Bar label="After debate" score={after.score} color={color} testid="agreement-after-score" />}
      <p className="pt-1 text-sm text-slate-400">
        <span data-testid="agreement-level" className="font-semibold" style={{ color }}>{label}{after ? " after debate" : ""}.</span>{" "}
        <span data-testid="agreement-summary">{shown.summary}</span>
      </p>
    </div>
  );
};
